import { cva, type VariantProps } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-v2-md font-semibold transition-[background-color,box-shadow,color,filter] duration-[var(--duration-v2-base)] ease-[var(--ease-v2)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-v2-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-v2-primary text-white hover:brightness-95',
        secondary:
          'border border-v2-border bg-v2-surface text-v2-ink hover:border-v2-primary',
        ghost: 'bg-transparent text-v2-ink hover:bg-v2-primary-soft',
        link: 'bg-transparent text-v2-primary underline-offset-4 hover:underline',
      },
      size: {
        md: 'min-h-12 px-6 text-[15px]', // 48px — 主要 CTA 既定
        sm: 'min-h-11 px-4 text-sm', // 44px — 補助操作
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
)

export type ButtonVariantProps = VariantProps<typeof buttonVariants>
